import Vue from 'vue';
import Vuex from 'vuex';
import form from './form/form';
import login from './login/login';
import register from './register/register';
import selectsheet from './selectsheet/selectsheet';
import error from './error';
import loading from './loading';
import notification from './notification/SaveNotification';

Vue.use(Vuex);

export default new Vuex.Store({
    getters: {
        getIsIosDevice() {
            return !!navigator.platform && /iPad|iPhone|MacIntel|iPod/.test(navigator.platform) && /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
        },
    },
    modules: {
        form,
        login,
        register,
        selectsheet,
        error,
        loading,
        notification,
    },
});
